import PropTypes from "prop-types"
import { Wrapper, Content } from "./MovieInfoBar.styles"

//helper
import { calcTime, convertMoney } from "../../helpers"

const MovieInfoBar = ({ time, budget, revenue }) => {
    return (
        <Wrapper>
            <Content>
                <div className="column">
                    <p>Running Time: {calcTime(time)}</p>
                </div>
                <div className="column">
                    <p>Budget: {convertMoney(budget)}</p>
                </div>
                <div className="column">
                    <p>Revenue: {convertMoney(revenue)}</p>
                </div>
            </Content>
        </Wrapper>
    )
}

MovieInfoBar.propTypes = {
    time: PropTypes.number,
    calcTime: PropTypes.number,
    convertMoney: PropTypes.number
}


export default MovieInfoBar
